import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NfcReaderService {
  constructor(private apiService: ApiService) { }

  /**
   * Get status data for all stores
   * @param startDate ISO date string
   * @param endDate ISO date string
   * @param interval Time grouping interval: '15min', 'hour', 'day', 'month'
   */
  getAllStoresStatusData(startDate?: string, endDate?: string, interval: string = '15min'): Observable<any> {
    let url = 'admin/nfc-readers/status';
    
    // Add query parameters if provided
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (interval) params.push(`interval=${interval}`);
    
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    
    return this.apiService.getRequest(url);
  }

  /**
   * Get status data for a specific store
   * @param storeId Store MongoDB ID
   * @param startDate ISO date string
   * @param endDate ISO date string
   * @param interval Time grouping interval: '15min', 'hour', 'day', 'month'
   */
  getStoreStatusData(storeId: string, startDate?: string, endDate?: string, interval: string = '15min'): Observable<any> {
    let url = `admin/nfc-readers/status/${storeId}`;
    
    // Add query parameters if provided
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (interval) params.push(`interval=${interval}`);
    
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    
    return this.apiService.getRequest(url);
  }

  /**
   * Manually trigger NFC reader monitoring
   * @param forceEmail Force sending email alerts
   */
  triggerNfcMonitoring(forceEmail?: boolean): Observable<any> {
    let url = 'admin/test-nfc-monitor';
    
    if (forceEmail) {
      url += `?forceEmail=true`;
    }
    
    return this.apiService.getRequest(url);
  }
} 